"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Basket_module_1 = require("./modules/Basket.module");
const loadDeliveryConditionsBannerModule = () => ({
    hasRouter: false,
    modules: [(0, Basket_module_1.default)()],
});
exports.default = loadDeliveryConditionsBannerModule;
